import { RefreshCw } from "lucide-react";
import { useAuth } from "../../../../../context/AuthContext";
import { dictionary } from "../../../../../utils/dictionary";

export const UpdateButton = ({ onClick }: { onClick: () => void }) => {
  const { language } = useAuth();
  return (
    <button
      onClick={onClick}
      className="w-full py-2 px-4 text-sm font-semibold border border-green-600 text-green-600 hover:bg-green-100 rounded-lg flex items-center justify-between transition-colors"
    >
      {dictionary["update"][language]} <RefreshCw size={16} />
    </button>
  );
};

export default UpdateButton;
